import React from 'react';
import eighteenPlus from '../../../../assets/images/eighteenPlus.svg';
import beGambleAware from '../../../../assets/images/beGambleAware.png';
import ga from '../../../../assets/images/ga.svg';
import gt from '../../../../assets/images/gt.svg';
import gamCare from '../../../../assets/images/gamCare.svg';
import talkBanStop from '../../../../assets/images/talkBanStop.svg';
import gbga from '../../../../assets/images/gbga.svg';
import gamStop from '../../../../assets/images/gamStop.svg';
import hmGovernmentOfGibraltar from '../../../../assets/images/hmGovernmentOfGibraltar.svg';
import mga from '../../../../assets/images/mga.svg';
import sg from '../../../../assets/images/sg.svg';
import gamblingCommission from '../../../../assets/images/gamblingCommission.svg';
import takeTimeToThink from '../../../../assets/images/takeTimeToThink.svg';
import beGambleAwareInverted from '../../../../assets/images/beGambleAwareInverted.png';
import eighteenPlusInverted from '../../../../assets/images/eighteenPlusInverted.svg';
import appleAppImage from '../../../../assets/images/apple-app.svg';
import googleAppImage from '../../../../assets/images/google-app.svg';

export const footerLinks = [
  {
    title: 'Help',
    links: [
      {
        text: 'Your Feedback',
        url: 'https://williamhill-lang.custhelp.com/'
      },
      {
        text: 'Help',
        url: 'https://www.williamhill.com/help'
      },
      {
        text: 'Gaming Fairness',
        url: 'https://www.williamhill.com/app/answers/detail/a_id/22201'
      },
      {
        text: 'Safer Gambling Hub',
        url: 'https://sports.williamhill.com/betting/en-gb?myAccountView=saferGambling'
      }
    ]
  },
  {
    title: 'Terms & Privacy',
    links: [
      {
        text: 'Terms & Conditions UK',
        url: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/6719'
      },
      {
        text: 'Terms & Conditions Non-UK',
        url: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/24787'
      },
      {
        text: 'Privacy Policy',
        url: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/6721/'
      },
      {
        text: 'Rules',
        url: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2063'
      }
    ]
  },
  {
    title: 'Join Us',
    links: [
      {
        text: 'Jobs & Careers',
        url: 'https://www.williamhillgroup.com/careers'
      },
      {
        text: 'Affiliate Program',
        url: 'https://affiliates.williamhill.com/'
      },
      {
        text: 'William Hill Press Office',
        url: 'https://www.williamhillgroup.com/'
      }
    ]
  },
  {
    title: 'Find Us',
    links: [
      {
        text: 'About William Hill',
        url: 'https://www.williamhillgroup.com/'
      },
      {
        text: 'Contact Us',
        url: 'https://www.williamhill.com/app/ask'
      },
      {
        text: 'Shop Locator',
        url: 'http://www.williamhill.com/shop-locator/'
      }
    ]
  },
  {
    title: 'Our Products',
    links: [
      {
        text: 'Sports',
        url: 'https://sports.williamhill.com/'
      },
      {
        text: 'Vegas',
        url: 'https://vegas.williamhill.com/'
      },
      {
        text: 'Live Casino',
        url: 'https://vegas.williamhill.com/live-casino'
      },
      {
        text: 'Poker',
        url: 'https://poker.williamhill.com/'
      }
    ]
  }
];

export const appLinks = (mobile) => {
  const applyClass = `${mobile ? 'mobile-' : ''}footer-app-links`;
  return (
    <div className={applyClass}>
      <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/gb/app/william-hill-sports-betting/id465712788">
        <img src={appleAppImage} />
      </a>
      <a target="_blank" rel="noopener noreferrer" href="https://apps.williamhill/en-mt/guide.html">
        <img src={googleAppImage} />
      </a>
    </div>
  );
};

export const copy = (
  <div className="footer-copy">
    <p>
      William Hill is operated by WHG (International) Limited, a company registered in Gibraltar. WHG (International) Limited is licensed and regulated in Great Britain by the Gambling Commission under account number
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://www.gamblingcommission.gov.uk/public-register/business/detail/39225"> 39225 </a>
      for customers in Great Britain and further licensed by the Government of Gibraltar and regulated by the
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling"> Gibraltar Gambling Commissioner</a>. The registered office of William Hill is at 6/1 Waterport Place, Gibraltar, with registered company number 99191. William Hill is a registered
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://www.ibas-uk.com/"> I.B.A.S </a>bookmaker.
    </p>
    <br />
    <p>
      For customers outside of Great Britain, this website is operated by William Hill Global PLC, a company registered in Malta with registration number C96298 and registered office at William Hill Global PLC, Tagliaferro Business Centre, Level 7, High Street, Sliema SLM 1549, Malta. WHG PLC operates in accordance with
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://authorisation.mga.org.mt/verification.aspx?lang=EN&amp;company=3358d23c-c63c-4fff-a7e2-079ca9a464f4&amp;details=1"> Malta Gaming Authority </a>
      under license: MGA/CRP/121/2006-05 issued on the 2nd of November 2020.
    </p>
    <br />
    <p>
      Underage gambling is an offence. William Hill is committed to helping you to gamble safely. For more information on the tools available to help to keep you safe please visit our
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733"> Safer Gambling </a>
      page. If you want advice or support you can call the
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://www.gamcare.org.uk/get-support/talk-to-us-now/"> National Gambling Helpline on 0808 8020 133 </a>
      (England, Scotland and Wales or visit
      <a className="footer-copy-link" target="_blank" rel="noopener noreferrer" href="https://www.gamblingtherapy.org/en"> gamblingtherapy.org</a>).
    </p>
  </div>
);

export const logos = (mobile) => {
  const containerClass = `${mobile ? 'mobile-' : ''}footer-logos`;
  const logoClass = mobile ? 'mobile-footer-logo' : '';
  return (
    <div className={containerClass}>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.williamhill.com/app/answers/detail/a_id/2960" target="_blank">
        <img src={eighteenPlus} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.begambleaware.org/" target="_blank">
        <img src={beGambleAware} width="100px" height="22" />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gamblersanonymous.org.uk/" target="_blank">
        <img src={ga} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gamblingtherapy.org/en" target="_blank">
        <img src={gt} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gamcare.org.uk/get-support/talk-to-us-now" target="_blank">
        <img src={gamCare} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gamcare.org.uk/talk/" target="_blank">
        <img src={talkBanStop} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="http://gbga.gi/" target="_blank">
        <img src={gbga} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gamstop.co.uk/" target="_blank">
        <img src={gamStop} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gibraltar.gov.gi/" target="_blank">
        <img src={hmGovernmentOfGibraltar} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://authorisation.mga.org.mt/verification.aspx?lang=EN&amp;company=3358d23c-c63c-4fff-a7e2-079ca9a464f4&amp;details=1" target="_blank">
        <img src={mga} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.williamhill.com/app/answers/detail/a_id/2733" target="_blank">
        <img src={sg} />
      </a>
      <a className={logoClass} rel="noopener noreferrer" href="https://www.gamblingcommission.gov.uk/" target="_blank">
        <img src={gamblingCommission} />
      </a>
    </div>
  );
};

export const copyright = (
  <div className="footer-copyright">
    © 1998-{new Date().getFullYear()} WHG (International) Ltd
  </div>
);

export const banner = (
  <div className="footer-banner">
    <a href="https://www.taketimetothink.co.uk/" rel="noopener noreferrer" target="_blank">
      <img src={takeTimeToThink} />
    </a>
    <a href="https://www.begambleaware.org/" rel="noopener noreferrer" target="_blank">
      <img src={beGambleAwareInverted} width="85px" height="20" />
    </a>
    <a href="https://www.williamhill.com/app/answers/detail/a_id/2960" rel="noopener noreferrer" target="_blank">
      <img src={eighteenPlusInverted} />
    </a>
  </div>
);
